/* ==================================================
   WWC Tabbed Search
   HTML: snippets/wwc-tabbed-search.liquid
   CSS: assets/custom.css
================================================== */

(function () {
  const roots = document.querySelectorAll('[data-wwc-ts]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    if (root.dataset.inited === '1') return;
    root.dataset.inited = '1';

    const configEl = root.querySelector('[data-wwc-ts-config]');
    let cfg = {};

    try {
      cfg = JSON.parse(configEl ? configEl.textContent : '{}');
    } catch (error) {
      cfg = {};
    }

    const T = cfg.labels || {};
    const inputWrap = root.querySelector('.wwc-ts-inputwrap');
    const input = root.querySelector('[data-input]');
    const panel = root.querySelector('[data-panel]');
    const stage = root.querySelector('[data-stage]');
    const clear = root.querySelector('.wwc-ts-clear');
    const tabs = Array.prototype.slice.call(root.querySelectorAll('.wwc-ts-tab'));
    const tabRij = root.querySelector('.wwc-ts-tabs');
    const inlineResults = String(root.dataset.inlineResults || '') === 'true';

    if (!inputWrap || !input || !panel || !stage) return;

    const rootUrl = normalizeRootUrl(root.dataset.rootUrl || '/');
    const allPlacesUrl = root.dataset.allPlacesUrl || '/pages/alle-steden';
    const cityIndexUrl = root.dataset.cityIndexUrl || '/pages/alle-steden?view=wwc-city-index';

    const CACHE = new Map();
    const CACHE_VERSION = 'v18-pages-articles-safe-header';

    let cityIndex = [];
    let productGroupIndex = [];
    let cityIndexLoaded = false;
    let activeRequest = null;
    let activeTab = root.dataset.showHelp === 'true' ? 'help' : 'all';
    let activeLayer = null;

    let currentData = emptyData();

    function bool(key) {
      return root.dataset[key] === 'true';
    }

    /* Meten. Zelfde vorm als wwc-city-browser.js en wwc-search-page.js. */
    function meld(naam, gegevens) {
      if (!window.dataLayer) return;

      window.dataLayer.push(Object.assign({ event: naam }, gegevens || {}));
    }

    /* Niet bij elke toetsaanslag. Het paneel ververst na 170 ms - goed voor
       suggesties, veel te snel voor een rapportage, want dan staan "u", "ut" en
       "utr" als drie zoekopdrachten in GA4. Dezelfde afweging als bij de
       zoekpagina, alleen hangt er hier geen adresbalk-wijziging aan vast, dus
       1200 ms volstaat. */
    /* Een timer PER gebeurtenisnaam, niet één gedeelde. Met een gedeelde timer
       wiste wwc_zoek_geen_resultaat de al ingeplande wwc_zoek_term van dezelfde
       zoekopdracht, en verdween die zoekterm uit de rapportage precies bij de
       zoekopdrachten die we het hardst nodig hebben. Gemeten op 1 september. */
    const meldTimers = {};

    function meldStraks(naam, gegevens, ms) {
      clearTimeout(meldTimers[naam]);
      meldTimers[naam] = setTimeout(function () {
        meld(naam, gegevens);
      }, ms || 1200);
    }

    function emptyData() {
      return {
        regions: [],
        collections: [],
        productgroups: [],
        products: [],
        pages: [],
        articles: []
      };
    }

    function normalizeRootUrl(value) {
      let url = String(value || '/').trim();

      if (!url) return '/';
      if (url.charAt(0) !== '/') url = '/' + url;
      if (url.charAt(url.length - 1) !== '/') url += '/';

      return url;
    }

    function localUrl(path) {
      if (!path) return rootUrl;

      const value = String(path).trim();

      if (value.indexOf('http') === 0) return value;

      // Liquid en de Shopify-zoek-API leveren URL's al mét taalprefix (/en/…).
      // Die er nóg een keer voor zetten geeft /en/en/… en dus een dode link.
      if (rootUrl !== '/' && (value + '/').indexOf(rootUrl) === 0) return value;

      return rootUrl + value.replace(/^\/+/, '');
    }

    function resultUrl(value, fallbackPath) {
      const raw = String(value || '').trim();

      if (raw.indexOf('http') === 0) return raw;
      if (raw.charAt(0) === '/') return raw;
      if (raw) return localUrl(raw);

      return localUrl(fallbackPath || '');
    }

    function esc(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function norm(value) {
      return String(value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/['’`"]/g, '')
        .trim();
    }

    const alias = new Map([
      ['gruningen', 'groningen'],
      ['groeningen', 'groningen'],
      ['grunn', 'groningen'],
      ['the hague', 'den haag'],
      ['s gravenhage', 'den haag'],
      ["'s-gravenhage", 'den haag'],
      ['s-hertogenbosch', 'den bosch'],
      ['den bosch', 'den bosch'],
      ['mestreech', 'maastricht'],
      ['ljouwert', 'leeuwarden']
    ]);

    function resolve(query) {
      return alias.get(norm(query)) || norm(query);
    }

    function handleize(value) {
      return norm(value).replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
    }

    function flag(country) {
      const map = {
        nederland: '🇳🇱',
        netherlands: '🇳🇱',
        paysbas: '🇳🇱',
        niederlande: '🇳🇱',
        belgie: '🇧🇪',
        belgium: '🇧🇪',
        belgique: '🇧🇪',
        belgien: '🇧🇪',
        duitsland: '🇩🇪',
        germany: '🇩🇪',
        deutschland: '🇩🇪',
        allemagne: '🇩🇪',
        frankrijk: '🇫🇷',
        france: '🇫🇷',
        spanje: '🇪🇸',
        spain: '🇪🇸',
        espagne: '🇪🇸',
        spanien: '🇪🇸',
        italie: '🇮🇹',
        italy: '🇮🇹',
        italien: '🇮🇹',
        canada: '🇨🇦',
        turkije: '🇹🇷',
        turkey: '🇹🇷',
        turquie: '🇹🇷',
        zweden: '🇸🇪',
        sweden: '🇸🇪',
        suede: '🇸🇪',
        schweden: '🇸🇪',
        oostenrijk: '🇦🇹',
        austria: '🇦🇹',
        autriche: '🇦🇹',
        osterreich: '🇦🇹',
        singapore: '🇸🇬'
      };

      return map[handleize(country)] || map[norm(country)] || '';
    }

    function getLimit() {
      const mobile = Number(root.dataset.limitMobile || 4);
      const desktop = Number(root.dataset.limitDesktop || 6);

      return window.matchMedia('(max-width: 640px)').matches ? mobile : desktop;
    }

    function setActiveLayer() {
      const z = root.dataset.zIndex || '9000';

      activeLayer = root.closest(
        '.wwc-main-search, [class*="text-block-content-"], .site-header, .header-wrapper, header, .shopify-section'
      );

      root.classList.add('is-open');

      if (activeLayer) {
        activeLayer.classList.add('wwc-ts-layer-open');
        activeLayer.style.setProperty('--wwc-active-z', String(z).trim());
      }
    }

    function clearActiveLayer() {
      root.classList.remove('is-open');

      if (activeLayer) {
        activeLayer.classList.remove('wwc-ts-layer-open');
        activeLayer.style.removeProperty('--wwc-active-z');
      }

      activeLayer = null;
    }

    /* Inline-stand: het paneel gaat niet open.

       Op de zoekpagina staan de resultaten al in de pagina. Ging het paneel daar
       óók open, dan beantwoordde de pagina dezelfde vraag twee keer - een
       zwevende lijst over een lijst. De module levert daar alleen het
       invoerveld; wwc-search-page.js luistert naar `wwc:inline-query` en werkt
       de pagina zelf bij. */
    function openPanel() {
      if (inlineResults) return;

      /* Alleen de overgang meten. openPanel() wordt bij elke toetsaanslag
         opnieuw aangeroepen; zonder deze controle telt elk teken als een
         opening. */
      const wasDicht = !panel.classList.contains('is-open');

      setActiveLayer();
      panel.classList.add('is-open');
      inputWrap.setAttribute('aria-expanded', 'true');

      if (wasDicht) {
        /* De plakkende balk en de loep zijn dezelfde module met dezelfde preset
           ('header'). Zonder dit onderscheid is in GA4 niet te zien welke van de
           twee het werk doet - en dat is precies de vraag of die balk zijn plek
           verdient. De header zet data-wwc-geforceerd op de omhullende balk
           zodra de loep hem opent (header.liquid r.303) en haalt hem weg bij
           sluiten (r.317). Instanties buiten een plakkende balk - zoekpagina,
           homepage - melden 'vast'. */
        const stickyWrap = root.closest('.wwc-sticky-search-wrap');
        let opening = 'vast';

        if (stickyWrap) {
          opening = stickyWrap.dataset.wwcGeforceerd ? 'loep' : 'plakkend';
        }

        meld('wwc_zoek_geopend', {
          zoek_bron: root.dataset.preset || 'onbekend',
          zoek_opening: opening
        });
      }
    }

    function closePanel() {
      panel.classList.remove('is-open');
      inputWrap.setAttribute('aria-expanded', 'false');
      clearActiveLayer();
    }

    async function loadCityIndex() {
      if (cityIndexLoaded && (cityIndex.length || productGroupIndex.length)) return;

      try {
        const url = new URL(localUrl(cityIndexUrl), window.location.origin);
        url.searchParams.set('view', 'wwc-city-index');

        const res = await fetch(url.toString(), { credentials: 'same-origin' });
        const text = await res.text();
        const json = JSON.parse(text);

        cityIndex = Array.isArray(json.items) ? json.items : [];
        productGroupIndex = Array.isArray(json.productgroups) ? json.productgroups : [];

        cityIndexLoaded = true;
        window.WWCCityIndex = cityIndex;
        window.WWCProductGroupIndex = productGroupIndex;
      } catch (error) {
        console.warn('WWC search JSON failed:', error);
        cityIndex = [];
        productGroupIndex = [];
        cityIndexLoaded = false;
      }
    }

    function levenshtein(a, b) {
      a = norm(a);
      b = norm(b);

      const m = Array.from({ length: b.length + 1 }, function (_, i) {
        return [i];
      });

      for (let j = 0; j <= a.length; j += 1) {
        m[0][j] = j;
      }

      for (let i = 1; i <= b.length; i += 1) {
        for (let j = 1; j <= a.length; j += 1) {
          m[i][j] = b[i - 1] === a[j - 1]
            ? m[i - 1][j - 1]
            : Math.min(
              m[i - 1][j - 1] + 1,
              m[i][j - 1] + 1,
              m[i - 1][j] + 1
            );
        }
      }

      return m[b.length][a.length];
    }

    function similarity(a, b) {
      return 1 - (levenshtein(a, b) / Math.max(norm(a).length, norm(b).length, 1));
    }

    /* Eén plek voor de gelijkenisregel.

       wwc-search-page.js moet dezelfde vraag beantwoorden - is dit een typefout
       of een plaats die we niet hebben - en met dezelfde uitkomst, anders zegt
       de zoekbalk iets anders dan de pagina eronder. Twee kopieën van dezelfde
       drempel lopen uiteen; dat is in dit thema al twee keer gebeurd (de
       is_city-blokkeerlijst en de dode aanvraaglink stonden allebei dubbel).

       DREMPEL is de bedrijfsregel: onder 0,64 noemen we het geen typefout meer.
       Gemeten op plaatsnamen: "Denekamp" tegen "Kampen" komt op 0,50 en wordt
       dus terecht niet als verschrijving aangeboden. */
    if (!window.WWCSearchHelpers) {
      window.WWCSearchHelpers = {
        norm: norm,
        levenshtein: levenshtein,
        similarity: similarity,
        DREMPEL: 0.64
      };
    }

    function cityLine(country, province) {
      return [country, province].filter(Boolean).join(' · ');
    }

    function destinationScore(item, query) {
      const q = resolve(query);
      const name = norm(item.plaats || item.title || '');
      const title = norm(item.title || '');
      const handle = norm(item.handle || '');

      if (!q) return 0;
      if (name === q) return 100;
      if (name.startsWith(q)) return 90;
      if (name.includes(q)) return 75;
      if (title.includes(q)) return 60;
      if (handle.includes(q)) return 45;

      const sim = similarity(q, name);
      if (q.length >= 4 && sim >= 0.64) return Math.round(sim * 60);

      return 0;
    }

    function buildDestinations(query) {
      if (!bool('showCollections')) return [];

      return cityIndex
        .filter(function (item) {
          return item.country || item.provincie;
        })
        .map(function (item) {
          return { item: item, score: destinationScore(item, query) };
        })
        .filter(function (x) {
          return x.score > 0;
        })
        .sort(function (a, b) {
          return b.score - a.score;
        })
        .slice(0, getLimit())
        .map(function (x) {
          return {
            title: x.item.plaats || x.item.title,
            url: localUrl(x.item.url),
            handle: x.item.handle,
            image: x.item.image || '',
            sub: cityLine(x.item.country, x.item.provincie)
          };
        });
    }

    function buildRegions(query) {
      if (!bool('showGeo')) return [];

      const q = resolve(query);
      const countries = new Map();
      const provinces = new Map();

      cityIndex.forEach(function (item) {
        const country = String(item.country || '').trim();
        const province = String(item.provincie || '').trim();

        if (country && norm(country).includes(q)) {
          countries.set(norm(country), {
            title: `${flag(country)} ${country}`.trim(),
            url: `${localUrl(allPlacesUrl)}?land=${encodeURIComponent(handleize(country))}`,
            sub: '',
            badge: T.country
          });
        }

        if (country && province && norm(province).includes(q)) {
          provinces.set(norm(country) + '|' + norm(province), {
            title: province,
            url: `${localUrl(allPlacesUrl)}?land=${encodeURIComponent(handleize(country))}&prov=${encodeURIComponent(handleize(province))}`,
            sub: `${flag(country)} ${country}`.trim(),
            badge: T.province
          });
        }
      });

      return Array.from(countries.values())
        .concat(Array.from(provinces.values()))
        .slice(0, getLimit());
    }

    function normalizeSearchTerms(value) {
      if (!value) return [];

      if (Array.isArray(value)) {
        return value.map(function (v) {
          return String(v || '').trim();
        }).filter(Boolean);
      }

      if (typeof value === 'object') {
        return Object.values(value).map(function (v) {
          return String(v || '').trim();
        }).filter(Boolean);
      }

      return String(value).split(',').map(function (v) {
        return v.trim();
      }).filter(Boolean);
    }

    function singularizeWord(word) {
      return norm(word).replace(/en$/, '').replace(/ers$/, 'er').replace(/s$/, '');
    }

    function productGroupScore(group, query) {
      const q = resolve(query);
      const title = norm(group.title || '');
      const handle = norm(group.handle || '');
      const terms = normalizeSearchTerms(group.search_terms).map(norm).filter(function (t) {
        return t.length >= 3;
      });

      if (!q) return 0;
      if (title === q) return 100;
      if (terms.some(function (t) { return t === q; })) return 95;
      if (title.startsWith(q)) return 85;
      if (terms.some(function (t) { return t.startsWith(q); })) return 80;
      if (title.includes(q)) return 75;
      if (terms.some(function (t) { return t.includes(q); })) return 72;
      if (terms.some(function (t) { return q.includes(t); })) return 70;

      const qWords = q.split(/\s+/).filter(Boolean);
      if (terms.some(function (t) { return qWords.includes(t); })) return 68;

      const qs = singularizeWord(q);
      if (terms.some(function (t) {
        const ts = singularizeWord(t);
        return qs === ts || q.includes(ts) || ts.includes(qs);
      })) return 62;

      if (handle.includes(q) && q.length >= 4) return 35;

      return 0;
    }

    function buildProductGroups(query) {
      if (!bool('showProductgroups')) return [];

      return productGroupIndex
        .map(function (group) {
          return { group: group, score: productGroupScore(group, query) };
        })
        .filter(function (x) {
          return x.score > 0;
        })
        .sort(function (a, b) {
          if (a.score !== b.score) return b.score - a.score;

          const ap = Number(a.group.priority || 0);
          const bp = Number(b.group.priority || 0);

          if (ap !== bp) return bp - ap;

          return norm(a.group.title).localeCompare(norm(b.group.title), 'nl');
        })
        .slice(0, getLimit())
        .map(function (x) {
          return {
            title: x.group.title,
            url: localUrl(x.group.url),
            handle: x.group.handle,
            image: x.group.image || '',
            sub: '',
            badge: T.productgroups
          };
        });
    }

    function imageUrl(item) {
      if (!item || !item.image) return '';
      if (typeof item.image === 'string') return item.image;
      if (item.image.url) return item.image.url;

      return '';
    }

    async function fetchPredictive(query) {
      const types = [];

      if (bool('showProducts')) types.push('product');
      if (bool('showPages')) types.push('page');
      if (bool('showArticles')) types.push('article');

      if (!types.length) {
        return { products: [], pages: [], articles: [] };
      }

      if (activeRequest) activeRequest.abort();
      activeRequest = new AbortController();

      const url =
        `${localUrl('search/suggest.json')}` +
        `?q=${encodeURIComponent(query)}` +
        `&resources[type]=${encodeURIComponent(types.join(','))}` +
        `&resources[limit]=20` +
        `&resources[options][unavailable_products]=hide`;

      try {
        const res = await fetch(url, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          signal: activeRequest.signal
        });

        const json = res.ok ? await res.json() : null;
        const results = json && json.resources && json.resources.results ? json.resources.results : {};

        const products = Array.isArray(results.products) ? results.products : [];
        const pages = Array.isArray(results.pages) ? results.pages : [];
        const articles = Array.isArray(results.articles) ? results.articles : [];

        return {
          products: products.slice(0, getLimit()).map(function (p) {
            return {
              title: p.title,
              url: resultUrl(p.url, p.handle ? `products/${p.handle}` : ''),
              handle: p.handle || '',
              image: imageUrl(p),
              sub: '',
              badge: ''
            };
          }),

          pages: pages.slice(0, getLimit()).map(function (p) {
            return {
              title: p.title,
              url: resultUrl(p.url, p.handle ? `pages/${p.handle}` : ''),
              handle: p.handle || '',
              image: imageUrl(p),
              sub: T.pages || '',
              badge: T.pages || ''
            };
          }),

          articles: articles.slice(0, getLimit()).map(function (a) {
            return {
              title: a.title,
              url: resultUrl(a.url, ''),
              handle: a.handle || '',
              image: imageUrl(a),
              sub: a.blog_title || T.articles || '',
              badge: T.articles || ''
            };
          })
        };
      } catch (error) {
        if (error.name === 'AbortError') throw error;

        return { products: [], pages: [], articles: [] };
      }
    }

    function getDidYouMean(query) {
      if (!bool('showDidYouMean')) return null;

      const q = resolve(query);
      if (!q || q.length < 3 || !cityIndex.length) return null;

      let best = null;

      cityIndex
        .filter(function (item) {
          return item.country || item.provincie;
        })
        .forEach(function (item) {
          const name = item.plaats || '';
          if (!name) return;

          const score = similarity(q, name);

          if (!best || score > best.score) {
            best = { name: name, score: score, url: item.url };
          }
        });

      if (!best || best.score < window.WWCSearchHelpers.DREMPEL || norm(best.name) === norm(q)) return null;

      return best;
    }

    function didYouMeanHtml(query) {
      const suggestion = getDidYouMean(query);
      if (!suggestion) return '';

      return `<div class="wwc-ts-dym">${esc(T.dym)} <a href="${esc(localUrl(suggestion.url))}">${esc(suggestion.name)}</a>?</div>`;
    }

    function updateTabs() {
      const counts = {
        all:
          currentData.collections.length +
          currentData.regions.length +
          currentData.productgroups.length +
          currentData.products.length +
          currentData.articles.length +
          currentData.pages.length,
        collections: currentData.collections.length + currentData.regions.length,
        productgroups: currentData.productgroups.length,
        products: currentData.products.length,
        articles: currentData.articles.length,
        pages: currentData.pages.length,
        help: 0
      };

      /* Geen resultaten = geen tabrij.

         In de lege staat staan alle tellers op nul en blijft alleen "Help"
         over, want die tab wordt hieronder bewust altijd getoond. Eén losse pil
         die niets filtert leest als een knop die stuk is. Zichtbaar geworden
         toen de loep de zoekbalk ging openen: sindsdien is de lege staat wat
         iemand als eerste ziet, in plaats van een randgeval. */
      if (tabRij) tabRij.hidden = counts.all === 0;

      tabs.forEach(function (btn) {
        const key = btn.dataset.tab;
        const enabled = key === 'help' || counts[key] > 0;

        btn.textContent = T.tabs && T.tabs[key] ? T.tabs[key] : key;

        if (bool('showTabCounts') && key !== 'help') {
          btn.textContent += ` (${counts[key] || 0})`;
        }

        btn.style.display = bool('hideEmptyTabs') && key !== 'help' && !enabled ? 'none' : '';
        btn.toggleAttribute('disabled', !enabled);
        btn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      });
    }

    function itemHtml(kind, item) {
      const thumb = item.image
        ? `<img class="wwc-ts-thumb" src="${esc(item.image)}" alt="" loading="lazy">`
        : '<div class="wwc-ts-thumb"></div>';

      return `<a class="wwc-ts-item" href="${esc(item.url)}" data-kind="${esc(kind)}" data-handle="${esc(item.handle || '')}">
        ${thumb}
        <div>
          <div class="wwc-ts-title">${esc(item.title)}</div>
          <div class="wwc-ts-sub">${esc(item.sub || '')}</div>
          ${item.badge ? `<div class="wwc-ts-badge">${esc(item.badge)}</div>` : ''}
        </div>
      </a>`;
    }

    function groupHtml(kind, items, label) {
      if (!items.length) return '';

      return `<div class="wwc-ts-groupwrap" data-group="${esc(kind)}">
        <span class="wwc-ts-group">${esc(label)}</span>
        <div class="wwc-ts-items">${items.map(function (i) {
          return itemHtml(kind, i);
        }).join('')}</div>
      </div>`;
    }

    function moreHtml(label, url) {
      if (!url) return '';

      return `<div class="wwc-ts-more"><a href="${esc(url)}">${esc(label)}</a></div>`;
    }

    function helpHtml(showZero) {
      if (!bool('showHelp')) return '';

      let html = '<div class="wwc-ts-help">';

      html += showZero
        ? `<div class="wwc-ts-help-title">${esc(T.emptyTitle)}</div><div class="wwc-ts-sub" style="font-size:14px;margin:0 0 12px 2px;">${esc(T.emptySub)}</div>${didYouMeanHtml(input.value)}`
        : `<div class="wwc-ts-help-title">${esc(T.helpTitle)}</div>`;

      if (bool('showTopSearches')) {
        const topSearches = Array.isArray(cfg.topSearches) ? cfg.topSearches : [];

        html += `<div class="wwc-ts-groupwrap"><span class="wwc-ts-group">${esc(T.top)}</span><div class="wwc-ts-chiprow">${
          topSearches.map(function (i) {
            return `<a class="wwc-ts-chip" href="${esc(localUrl(i.url))}">${esc(i.label)}</a>`;
          }).join('')
        }</div></div>`;
      }

      /* In de beginstand - paneel open, nog niets getypt - blijven de
         uitgangkaarten weg. Ze dragen een productfoto en een bestelbare link, en
         naast een leeg zoekveld stelt dat twee vragen tegelijk: moet ik zoeken
         of moet ik dit product bekijken? Zodra er een zoekterm staat is de vraag
         beantwoord en horen ze er weer bij - of er nu resultaten zijn of niet.
         Terugzetten voor een test kan met show_help_buttons_initial. */
      const beginstand = !input.value.trim();

      if (bool('showHelpButtons') && (!beginstand || bool('showHelpButtonsInitial'))) {
        const helpCards = Array.isArray(cfg.helpCards) ? cfg.helpCards : [];

        html += `<div class="wwc-ts-cta-grid">${
          helpCards.map(function (c) {
            /* De eerste kaart is de uitweg die vandaag nog tot een bestelling
               leidt, en krijgt daarom een productfoto en de volle breedte. De
               rest blijft tekst. Zonder dat onderscheid las Jouw Plek als de
               vierde regel van een opsomming. */
            const primair = c.primair === true;
            const beeld = primair && c.image
              ? `<img class="wwc-ts-cta-foto" src="${esc(c.image)}" alt="" loading="lazy" width="72" height="72">`
              : `<div class="wwc-ts-cta-badge">${esc(c.badge)}</div>`;

            return `<a class="wwc-ts-cta${primair ? ' wwc-ts-cta--primair' : ''}" href="${esc(localUrl(c.url))}">
              ${beeld}
              <div>
                <div class="wwc-ts-cta-title">${esc(c.title)}</div>
                <div class="wwc-ts-cta-sub">${esc(c.sub)}</div>
              </div>
            </a>`;
          }).join('')
        }</div>`;
      }

      html += '</div>';

      return html;
    }

    function searchUrl() {
      const q = input.value.trim();

      return localUrl(`search?q=${encodeURIComponent(q)}&type=product`);
    }

    function hasAnyResults() {
      return Boolean(
        currentData.collections.length ||
        currentData.regions.length ||
        currentData.productgroups.length ||
        currentData.products.length ||
        currentData.articles.length ||
        currentData.pages.length
      );
    }

    function safeFallbackTab(tab) {
      const existing = tabs.some(function (btn) {
        return btn.dataset.tab === tab;
      });

      if (existing) return tab;

      return tabs.length ? tabs[0].dataset.tab : 'all';
    }

    function renderStage(tab) {
      activeTab = safeFallbackTab(tab);
      updateTabs();

      tabs.forEach(function (btn) {
        btn.setAttribute('aria-selected', btn.dataset.tab === activeTab ? 'true' : 'false');
      });

      let html = '';

      if (activeTab === 'all') {
        html += groupHtml('collections', currentData.collections, T.collections);
        html += groupHtml('regions', currentData.regions, T.regions);
        html += groupHtml('productgroups', currentData.productgroups, T.productgroups);
        html += groupHtml('products', currentData.products, T.products);
        html += groupHtml('articles', currentData.articles, T.articles);
        html += groupHtml('pages', currentData.pages, T.pages);

        if (currentData.products.length) {
          html += moreHtml(T.moreProducts, searchUrl());
        }

        html += hasAnyResults() ? helpHtml(false) : helpHtml(true);
      }

      if (activeTab === 'collections') {
        html += groupHtml('collections', currentData.collections, T.collections);
        html += groupHtml('regions', currentData.regions, T.regions);

        if (!html) html = helpHtml(true);
      }

      if (activeTab === 'productgroups') {
        html = groupHtml('productgroups', currentData.productgroups, T.productgroups) || helpHtml(true);
      }

      if (activeTab === 'products') {
        html = groupHtml('products', currentData.products, T.products);

        if (currentData.products.length) {
          html += moreHtml(T.moreProducts, searchUrl());
        }

        if (!html) html = helpHtml(true);
      }

      if (activeTab === 'articles') {
        html = groupHtml('articles', currentData.articles, T.articles) || helpHtml(true);
      }

      if (activeTab === 'pages') {
        html = groupHtml('pages', currentData.pages, T.pages) || helpHtml(true);
      }

      if (activeTab === 'help') {
        html = helpHtml(false);
      }

      stage.innerHTML = html;
    }

    async function doSearch(query) {
      openPanel();
      stage.innerHTML = `<div class="wwc-ts-status">${esc(T.loading)}</div>`;

      const cacheKey =
        CACHE_VERSION +
        ':' + query +
        ':' + [
          bool('showProducts'),
          bool('showCollections'),
          bool('showProductgroups'),
          bool('showPages'),
          bool('showArticles'),
          bool('showGeo')
        ].join('|');

      if (CACHE.has(cacheKey)) {
        currentData = CACHE.get(cacheKey);
        renderStage('all');
        return;
      }

      await loadCityIndex();

      const collections = buildDestinations(query);
      const regions = buildRegions(query);
      const productgroups = buildProductGroups(query);

      let predictive = {
        products: [],
        pages: [],
        articles: []
      };

      try {
        predictive = await fetchPredictive(query);
      } catch (error) {
        predictive = {
          products: [],
          pages: [],
          articles: []
        };
      }

      currentData = {
        collections: collections,
        regions: regions,
        productgroups: productgroups,
        products: predictive.products,
        pages: predictive.pages,
        articles: predictive.articles
      };

      CACHE.set(cacheKey, currentData);

      if (CACHE.size > 20) {
        CACHE.delete(CACHE.keys().next().value);
      }

      renderStage('all');
      meldResultaat(query);
    }

    /* De lijst met zoekopdrachten zonder resultaat is precies de data die
       ontbreekt om te weten welke plaatsen we missen (sprint 6d). Daarom een
       eigen gebeurtenis en niet alleen een teller in wwc_zoek_term. */
    function meldResultaat(query) {
      const aantallen = {
        collecties: currentData.collections.length,
        regios: currentData.regions.length,
        productgroepen: currentData.productgroups.length,
        producten: currentData.products.length
      };
      const totaal =
        aantallen.collecties + aantallen.regios +
        aantallen.productgroepen + aantallen.producten +
        currentData.pages.length + currentData.articles.length;

      meldStraks('wwc_zoek_term', {
        zoek_term: query,
        zoek_resultaten: totaal,
        zoek_collecties: aantallen.collecties,
        zoek_producten: aantallen.producten
      });

      if (totaal === 0) {
        meldStraks('wwc_zoek_geen_resultaat', { zoek_term: query }, 1400);
      }
    }

    function debounce(fn, delay) {
      let timer;

      return function () {
        const args = arguments;

        clearTimeout(timer);

        timer = setTimeout(function () {
          fn.apply(null, args);
        }, delay);
      };
    }

    function meldInline(q) {
      root.dispatchEvent(new CustomEvent('wwc:inline-query', {
        bubbles: true,
        detail: { query: q }
      }));
    }

    /* Trager in de inline-stand: 170 ms is goed voor een paneel dat suggesties
       toont, maar hier hangt er een verzoek aan vast én een schrijfbeurt naar de
       adresbalk - en die telt bij GA4, Meta en Google Ads als paginaweergave.
       800 ms wacht tot iemand echt klaar is met typen; bij 450 ms leverde een
       denkpauze midden in een woord al een halve zoekterm in de statistieken
       ("utre" naast "utrecht"). Gemeten op 31 augustus 2026. */
    const runQuery = debounce(function () {
      const q = input.value.trim();

      // Het kruisje hoort weg zodra het veld leeg is; het stond er altijd.
      clear.classList.toggle('is-visible', q.length > 0);

      if (inlineResults) {
        meldInline(q);
        return;
      }

      if (!q || q.length < 2) {
        currentData = emptyData();
        renderStage(bool('showHelp') ? 'help' : 'all');
        openPanel();
        return;
      }

      doSearch(q);
    }, inlineResults ? 800 : 170);

    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!btn.disabled) {
          renderStage(btn.dataset.tab);
        }
      });
    });

    /* Klikken meten met delegatie: het paneel wordt bij elke zoekopdracht
       opnieuw opgebouwd, dus losse listeners op de items zouden telkens opnieuw
       gezet moeten worden en bij de eerstvolgende render weer verdwijnen. */
    stage.addEventListener('click', function (event) {
      const term = input.value.trim();

      const item = event.target.closest('.wwc-ts-item');

      if (item) {
        meld('wwc_zoek_klik', {
          zoek_term: term,
          zoek_soort: item.dataset.kind || '',
          zoek_bestemming: item.getAttribute('href') || ''
        });
        return;
      }

      const uitgang = event.target.closest('.wwc-ts-cta');

      if (uitgang) {
        meld('wwc_zoek_uitgang', {
          zoek_term: term,
          zoek_bestemming: uitgang.getAttribute('href') || ''
        });
        return;
      }

      const chip = event.target.closest('.wwc-ts-chip');

      if (chip) {
        meld('wwc_zoek_populair', {
          zoek_label: (chip.textContent || '').trim(),
          zoek_bestemming: chip.getAttribute('href') || ''
        });
      }
    });

    input.addEventListener('focus', function () {
      clear.classList.add('is-visible');
      if (inlineResults) return;
      openPanel();
      runQuery();
    });

    input.addEventListener('input', runQuery);

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        input.value = '';
        closePanel();
        clear.classList.remove('is-visible');
        // Ook Escape stuurt de pagina; het kruisje doet dat al.
        if (inlineResults) meldInline('');
      }

      if (event.key === 'Enter') {
        /* Inline: Enter bevestigt wat er staat, en dat is de pagina zelf. Niet
           doorspringen naar een eerste suggestie - er is geen suggestielijst. */
        if (inlineResults) {
          event.preventDefault();
          meldInline(input.value.trim());
          input.blur();
          return;
        }

        const first = stage.querySelector('.wwc-ts-item');

        if (first) {
          event.preventDefault();
          window.location.assign(first.href);
        }
      }
    });

    clear.addEventListener('click', function () {
      input.value = '';

      if (inlineResults) {
        meldInline('');
        clear.classList.remove('is-visible');
        input.blur();
        return;
      }

      currentData = emptyData();
      renderStage(bool('showHelp') ? 'help' : 'all');
      closePanel();
      clear.classList.remove('is-visible');
      input.blur();
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) {
        closePanel();
      }
    });

    window.addEventListener('resize', function () {
      renderStage(activeTab);
    });

    loadCityIndex();
    renderStage(bool('showHelp') ? 'help' : 'all');
    closePanel();
  });
})();